import React, { useState } from 'react'
import styles from "./submit.module.css";
import Button from '../../../button';
import mark_logo from "../../../../assets/mark.png";
import { notify } from '../../../toast';
import { CreateNewAppointment } from '../../../../utils/appointments';
import ConfettiExplosion from 'react-confetti-explosion';


const SubmitPopUp = (props) => {

  const roles = [
    "Susipažink su bendra informacija",
    "Sek naujienas el pašte",
  ]

  const [clients_phone, setPhoneValue] = useState("");
  const [clients_email, setEmailValue] = useState("");

  const [isFinished, setIsFinished] = useState(false);


  const onSubmitHandler = async() => {
    
    if(!clients_phone || clients_phone.length < 1)return notify("Įveskite tel. nr", "warning")
      
    try {
      
      const response = await CreateNewAppointment({
        clients_phone: clients_phone,
        appointment_date: props.day,
        appointment_time: props.time,
        appointment_service: props.service,
        project_id: process.env.REACT_APP_PROJECT_ID,
      })
      
      if(!response.status || !response.data)throw new Error(response.message)
      setIsFinished(true)

      setTimeout(() => {
        return props.onClose()
      }, 1000);


    } catch (error) {
      return notify(error.message || "Negalimas veiksmas", "error")
    }

  }
    
  return (
    <div className={styles.container}>

      <div className={styles.roles}>
        {
          roles.map((role, index) => {
            return <div key={index}>
              <img alt='' src={mark_logo} />
              <h2 style={{ color:"#94A7AE" }}>{role}</h2 >
            </div>
          })
        }
      </div>

      <div className={styles.inputbox}>
        <input value={clients_email} onChange={(text) => {setEmailValue(text.target.value)}} required="required" type="text" />
        <span>El. paštas</span>
        <i></i>
      </div>

      <div className={styles.inputbox}>
        <input value={clients_phone} onChange={(text) => {setPhoneValue(text.target.value)}} required="required" type="number" />
        <span>Telefono numeris</span>
        <i></i>
      </div>

      <div className={styles.controllers}>
        <Button onClick={onSubmitHandler}>Rezervuotis</Button>
      </div>

      { isFinished &&
        <div className={styles.congrats}>
          {true && <ConfettiExplosion zIndex={5} />}
        </div>
      }

    </div>
  )
}

export default SubmitPopUp